module.exports = __webpack_public_path__ + "media/נמר.7a731473.mp3";